import {
  Table,
  Container,
  Button,
  SpaceBetween,
  Header,
  Box,
  ContentLayout,
  ExpandableSection,
  Select,
  TableProps,
  Textarea,
  ColumnLayout,
  Link
} from '@cloudscape-design/components';

// context
// const evidences = [
//   { name: 'evidence 1' },
//   { name: 'evidence 2' },
//   { name: 'evidence 3' }
// ];
export const DocListHelpPanel = () => {

  return (
    <Container header={<Header variant="h2">{`Knowledge Mapping`}</Header>}>
      <>
        <h4>View Document</h4>
        <p>
          View Document Select one or more Koru Analyzed documents that have
          completed processing. You can view the detailed analysis for selected
          document(s). Make modifications to document analysis to review
          information from your Koru Knowledge Base related to compliance topics
          Koru has discovered.
        </p>
        <h4>Create Report</h4>
        <p>
          Generate a detailed analysis report spreadsheet for the document(s)
          selected. The report provides a full compliance analysis of every
          compliance topic Koru has discovered. You can use this report to
          develop action plans, assign tasks, create responses using
          authoritative information from your Koru Knowledge Base.
        </p>
      </>
    </Container>
  );
};
